import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mcb-client-status',
  templateUrl: './client-status.component.html'
})
export class ClientStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
